import React from "react";
import { Col, Row } from "antd";
import BillPrepayments from "../../components/BillsPrepayments/BillsPrepayments";
import { hasAccess } from "../../components/RolesModule/hasAccess";
import { MENU_BILLING_PREPAYMENTBILL_WRITE } from "../../lib/const/permissions";
import ErrorPage from "../../components/ErrorPage/ErrorPage";

const style = {
  border: {
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.05)",
  },
};

const BillsPrepaymentsContainer = () => {
  

  return (
    <div className="container_height" style={style.border}>
      <div className="inner-row">
        <Row justify="space-between" align="middle">
          <Col>
            <h1>Массовое выставление счетов на предоплату</h1>
          </Col>
        </Row>
        {hasAccess(MENU_BILLING_PREPAYMENTBILL_WRITE) ? <BillPrepayments /> : <ErrorPage />}
      </div>
    </div>
  );
};

export default BillsPrepaymentsContainer;
